export default "__VITE_ASSET__DLxRSdfW__"